<template>
  <div>
    <!-- Top Header -->
    <div class="top-header bg-light">
      <div class="container d-flex justify-content-end">
        <a href="#" class="me-3"><i class="fas fa-user"></i> Login</a>
        <a href="#"><i class="fas fa-user-circle"></i> My Account</a>
      </div>
    </div>

    <!-- Main Navbar -->
    <header>
      <nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm">
        <div class="container">
          <!-- Brand Logo -->
          <a
            class="navbar-brand"
            href="javascript:void(0)"
            @click="$router.push({ path: '/' })"
          >
            <img src="images/logo.png" alt="Bee's Atelier" height="40" />
          </a>

          <!-- Toggler -->
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Navbar Links -->
          <div class="collapse navbar-collapse" id="mainNav">
            <ul class="navbar-nav ms-auto">
              <!-- Home -->
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: isActive('/') }"
                  href="javascript:void(0)"
                  @click="$router.push({ path: '/' })"
                >
                  Home
                </a>
              </li>

              <!-- Shop Dropdown -->
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="shopDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  :class="{ active: isActive('/shop') }"
                >
                  Shop <i class="fa fa-chevron-down ms-1"></i>
                </a>
                <ul class="dropdown-menu">
                  <!-- All Products -->
                  <li>
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click="$router.push({ path: '/shop' })"
                    >
                      All Products
                    </a>
                  </li>

                  <!-- Dynamic Categories -->
                  <li
                    v-for="category in categories"
                    :key="category.slug"
                  >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click="$router.push({ name: 'ShopBySlug', params: { slug: category.slug } })"
                    >
                      {{ category.title }}
                    </a>

                  </li>
                </ul>
              </li>

              <!-- Other Static Pages -->
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="{ active: isActive('/workshops') }"
                >
                  Workshops
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="{ active: isActive('/about') }"
                >
                  About Bee's Atelier
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="{ active: isActive('/contact') }"
                >
                  Contact Us
                </a>
              </li>

              <!-- Cart -->
              <li class="nav-item">
                <a
                  class="nav-link cart-icon"
                  href="javascript:void(0)"
                  @click="$router.push({ path: '/cart' })"
                  :class="{ active: isActive('/cart') }"
                >
                  <i class="fas fa-shopping-cart"></i>
                  <span class="cart-badge">{{ cartItemsCount }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
import ProductService from "../services/ProductService";
import { useToast } from "vue-toast-notification";
const $toast = useToast();
import { EventBus } from '@/eventBus'

export default {
  name: "Header",
  data() {
    return {
      cartItemsCount: 0,
      categories: [],
    };
  },
  methods: {
    getCategories() {
      ProductService.getCategories()
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((e) => {
          $toast.error(e.response?.data?.response_msg || e.message);
        });
    },
    async getCartCount() {
        await ProductService.getCartCount()
        .then((response) => {
          this.cartItemsCount = response.data.data;
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    // Determine which menu is active
    isActive(path) {
      if (path === "/shop" && this.$route.path === "/shop") return true;
      if (path === "/") return this.$route.path === "/";
      return this.$route.path === path;
    },
  },
  watch: {
    '$route'(to, from) {
      this.getCartCount();
    },
  },
  created() {
    this.getCategories();
    this.getCartCount();
  },
  mounted() {
    EventBus.on('cart-updated', () => {
      this.getCartCount()
    })
  }
};
</script>

<style scoped>
.nav-link.active {
  color: #ff4e89 !important; /* your accent color */
  font-weight: 600;
}
</style>
